/* template */
<template><div class="mpx-root-view"><div :class="(isDrawer && 'drawer')" class="buy-ticket-card"><div :class="({'normal-padding-top': buttonType === 0})" class="buy-ticket-card-left"><mpx-image :src="(buttonIcon)" class="type-icon"/><div><div class="buy-ticket-type"><span class="type-writting">{{ purchaseType }}</span></div><div :class="({'normal-padding-left': buttonType === 0})" class="buy-ticket-description"><template v-if="(buttonType === 2)"><div v-for="(item, index) in (scrambleTextArr)" class="scramble-description"><mpx-image src="https://ut-static.udache.com/webx/sfc/O9Uo8R6LvK2QT9gNDMOSp.png" class="scramble-description-icon"/><div class="scramble-description-text">{{ item }}</div></div></template><template v-else><div class="buy-ticket-description-left">{{ leftDescription }}</div><div class="buy-ticket-description-right" v-if="(rightDescription)"><span>{{ rightDescription }}</span><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/xA27RuQfHS1691684676038.png" @tap="getServiceDescription" class="question-mark" v-if="(buttonType === 1)"/></div></template></div></div></div><mpx-view @tap="buyTicket" class="buy-ticket-card-right"><div class="ticket-price-area"><div class="ticket-price"><span :style="[({fontSize: '16px', marginRight: '2px' })] | transRpxStyle">¥</span>{{ showPrice }}</div><div class="discount-desc" v-if="(discountDesc)">{{ discountDesc }}</div></div><div :style="[(canTap ? '':'background: #CCCCCC')] | transRpxStyle" class="card-button">{{ btnText }}</div></mpx-view></div><privacy-toast :list="(privacyList)" @privacyVerify="privacyVerify" v-if="(showPrivacy)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m29d740e6"}'>
  @import '~@/mixins/stylus/color.styl'

  .buy-ticket-card
    display flex
    justify-content space-between
    align-items center
    padding 24px 0 23px
    // border-radius 8px
    // box-sizing border-box
    // background #ffffff
    // margin-bottom 10px
    &.drawer
      background #F6F9FD
      border-radius 10px
      padding-left 10px
      padding-right 12px
      margin-left -4px
      margin-right -4px
    .type-icon
      height 33px
      width 33px
      margin-right 6px
    .buy-ticket-card-left
      display flex
      // flex-direction column
      // justify-content space-between
      align-items center
      padding-top 1px
      box-sizing border-box
      .buy-ticket-type
        height 20px
        line-height 20px
        display flex
        align-items center
        position relative
        color #000000
        font-family PingFangSC-Medium
        margin-bottom 4px
        .type-writting
          font-size 16px
      .buy-ticket-description
        display flex
        height 13px
        line-height 13px
        font-size 12px
        font-family PingFangSC-Regular
        color #666
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
        .scramble-description
          height 16px
          display flex
          align-items center
          &:not(:last-child)
            margin-right 2px
          &-icon
            height 4px
            width 6px
            margin-right 2px
          &-text
            font-family PingFangSC-Regular
            font-size 12px
            line-height 14px
            color #666
        .buy-ticket-description-right
          display flex
          margin-left 12px
          position relative
          .question-mark
            margin-left 2px
            height 12px
            width 12px
          &::after
            content ''
            height 8px
            border 0.5px solid rgba(153, 153, 153, 0.7)
            position absolute
            top 50%
            left -6px
            transform translateY(-50%)
      .normal-padding-left
        padding-left 2px
    .normal-padding-top
      padding-top 3px
    .buy-ticket-card-right
      display flex
      align-items center
      .ticket-price-area
        color #FF6400
        display flex
        align-items flex-end
        flex-direction column
        min-width 58px
        .ticket-price
          height 24px
          line-height 24px
          font-size 22px
          font-family Barlow Semi Condensed
          font-weight 400
        .discount-desc
          font-family PingFangSC-Regular
          font-size 9px
          font-weight normal
          line-height 9px
          padding 1.5px
          border-radius 3px
          box-shadow 0px 0px 0px 0.5px #FFBC91
      .card-button
        margin-left 8px
        height 40px
        line-height 40px
        text-align center
        width 40px
        color #fff
        border-radius 10px
        background #FF6400
        font-size 16px
        font-family PingFangSC-Semibold
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m29d740e6"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex29d740e6%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex29d740e6%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m29d740e6"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index29d740e6/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'privacy-toast':getComponent(require("../privacy/index.mpx?isComponent&outputPath=components%2Findex6f368ef8%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
